<div class="wizard-container wizard-default">
  <!-- Step Indicators -->
  <ul class="wizard-steps" *ngIf="(isHandset$ | async) === false">
    <li *ngFor="let step of relevantSteps; let i = index" [class.active]="i === currentStepIndex">
      {{ step.label | translate }}
    </li>
  </ul>

  <!-- Step Content -->
  <div class="wizard-content card">
    <ng-container [ngSwitch]="currentStepIndex">
      <h1 *ngIf="(isHandset$ | async)" class="fs-3 fw-bold m-3">
        {{ steps[currentStepIndex].label | translate }}
      </h1>
      <form>
        <app-step1-profile-check-form
          *ngSwitchCase="0"
          #step1
          (profileCheckFormValid)="setProfileCheckFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
        >
        </app-step1-profile-check-form>

        <app-step2-event-location-form
          *ngSwitchCase="1"
          #step2
          (eventLocationFormValid)="setEventLocationFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
        >
        </app-step2-event-location-form>

        <app-step3-test-time-form
          *ngSwitchCase="2"
          #step3
          (timeSlotFormValid)="setTimeSlotFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
          [stepId]="stepId"
        >
        </app-step3-test-time-form>

        <app-step4-additional-questions-form
          *ngSwitchCase="3"
          #step4
          (additionalQuestionsFormValid)="setAdditionalQuestionsFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
        >
        </app-step4-additional-questions-form>

        <app-step5-booking-overview
          *ngSwitchCase="4"
          (overviewFormValid)="setOverviewFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
        >
        </app-step5-booking-overview>
      </form>
    </ng-container>
  </div>

  <!-- Navigation Controls -->
  <div class="d-flex justify-content-between">
    <div>
      <button
        *ngIf="!isFirstStep"
        class="btn btn-outline-primary me-3 mb-3"
        (click)="previousStep()"
        [disabled]="stepLoading"
      >
        {{ 'button.back' | translate }}
      </button>
      <button
        *ngIf="!isLastStep"
        class="btn btn-primary mb-3"
        (click)="handleNext()"
        [disabled]="!steps[currentStepIndex].isValid || stepLoading"
      >
        {{ 'button.next' | translate }}
      </button>
    </div>

    <div>
      <button
        class="btn btn-warning me-3 mb-3"
        [class]="isLastStep ? 'me-3' : ''"
        (click)="deleteBooking()"
        [disabled]="stepLoading"
      >
        {{ 'button.cancel' | translate }}
      </button>
      <button
        *ngIf="isLastStep"
        [disabled]="!overviewFormValid || isPayBtnClicked || stepLoading"
        class="btn btn-primary mb-3"
        (click)="doPayment()"
      >
        {{ 'button.pay-now' | translate }}
      </button>
    </div>
  </div>
</div>
